module.exports = __webpack_public_path__ + "img/6.99fadea9.jpg";